import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
    class: "maintenance-schedule-model",
    role: "group",
    "aria-labelledby": "MaintenanceScheduleModelQuestion"
};
const _hoisted_2 = ["value", "tabindex", "aria-disabled", "onClick", "onKeydown"];
const _hoisted_3 = { class: "model__image" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "model__name" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionModelAnswers, (model, index) => {
            return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "model",
                value: model.name,
                tabindex: _ctx.fieldIsDisabled ? null : 0,
                role: "radio",
                "aria-disabled": _ctx.fieldIsDisabled ? 'true' : null,
                "aria-checked": "false",
                onClick: ($event) => (_ctx.answered($event, model.name, model.modelPhotoUrl)),
                onKeydown: [
                    _withKeys(($event) => (_ctx.answered($event, model.name, model.modelPhotoUrl)), ["enter"]),
                    _withKeys(($event) => (_ctx.answered($event, model.name, model.modelPhotoUrl)), ["space"])
                ]
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                        src: model.modelPhotoUrl,
                        alt: model.name
                    }, null, 8 /* PROPS */, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(model.name), 1 /* TEXT */)
            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
